import axios from 'axios';
import { notifyUnauthorized } from './authEvents';

// ICP segments: the list, which segment each company is in, and the tools to change both
const apiClient = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL || '',
  timeout: 30000,
  headers: { 'Content-Type': 'application/json' }
});

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) notifyUnauthorized();
    return Promise.reject(error);
  }
);

const call = async (request, fallbackMessage) => {
  try {
    return (await request()).data;
  } catch (error) {
    const detail = error.response?.data?.detail;
    throw new Error(typeof detail === 'string' ? detail : fallbackMessage);
  }
};

const icpApi = {
  listSegments: () => call(() => apiClient.get('/api/v2/icp-segments'), "Couldn't load the ICP segments"),
  createSegment: (fields) => call(() => apiClient.post('/api/v2/icp-segments', fields), "Couldn't add the segment"),
  updateSegment: (segmentId, fields) => call(
    () => apiClient.patch(`/api/v2/icp-segments/${segmentId}`, fields), "Couldn't save the segment"),
  deleteSegment: (segmentId) => call(
    () => apiClient.delete(`/api/v2/icp-segments/${segmentId}`), "Couldn't remove the segment"),
  summary: () => call(() => apiClient.get('/api/v2/icp-segments/summary'), "Couldn't load the ICP summary"),
  // One bucket: icp_segment_id, or unclassified=true, or not_checked=true; with q, page and limit
  companiesIn: (params) => call(
    () => apiClient.get('/api/v2/icp-segments/companies', { params }), "Couldn't load the companies"),
  // A segment id, or null for Unclassified
  setCompanyIcp: (companyId, icpSegmentId) => call(
    () => apiClient.patch(`/api/v2/companies/${companyId}/icp`, { icp_segment_id: icpSegmentId }),
    "Couldn't save that"),
  // The next batch of companies for the classifier: after afterId (0 to start), or only the ones it placed
  // before when rerun is set. The server answers 409 when nothing is left, with the reason as its message.
  startClassifyRun: async ({ rerun = false, afterId = 0 }) => {
    try {
      return (await apiClient.post('/api/v2/icp-segments/classify-runs', { rerun, after_id: afterId })).data;
    } catch (error) {
      const detail = error.response?.data?.detail;
      const failure = new Error(typeof detail === 'string' ? detail : "Couldn't start the classifier");
      failure.status = error.response?.status;
      throw failure;
    }
  }
};

export default icpApi;
